import React, { useCallback, useEffect, useRef, useState } from "react";
import SpinnerPadrao from "./SpinnerPadrao";

export default function ScrollContainer({ listar, prevent, loading, children, ...rest }) {
  return <div {...rest}>
    {children}
    {loading && <div className="sticky-bottom" style={{ textAlign: 'center' }}>
      <SpinnerPadrao style={{ width: 50, height: 50 }} />
    </div>}
    <WaypointPadrao listar={listar} loading={loading} />
  </div>;
}

export function WaypointPadrao({ listar, loading }) {
  const [compScrollY, setCompScrollY] = useState(0);
  const obs = useRef();

  useEffect(() => {
    const drawer = document.querySelector(".ant-drawer-body");
    const scrollPadrao = document.querySelector(".scroll-container-padrao");

    function setScroll() {
      setCompScrollY((drawer || scrollPadrao).scrollTop);
    }

    if (!!drawer)
      drawer.addEventListener("scroll", setScroll);
    else if (!!scrollPadrao)
      scrollPadrao.addEventListener("scroll", setScroll);

    return () => {
      if (!!drawer)
        drawer.removeEventListener("scroll", setScroll);

      if (!!scrollPadrao)
        scrollPadrao.removeEventListener("scroll", setScroll);
    };
  }, []);

  const last = useCallback(node => {
    if (obs.current)
      obs.current.disconnect();

    if (loading)
      return;

    obs.current = new IntersectionObserver(ent => {
      if (ent[0].isIntersecting && !loading && (window.scrollY > 0 || compScrollY > 0))
        listar();
    });

    if (node)
      obs.current.observe(node);
  });

  return <div ref={last} style={{ width: 1, height: 1 }} />;
}

